import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { ProjectAlerts } from '../components/Advisor/ProjectAlerts';

export const AdvisorAlertsPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <ProjectAlerts />
      </div>
    </Layout>
  );
};